<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="textureSvc"></yo-generic-datagrid-pn>
